import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const CONTRACT_LEGACY_API = 'https://sgxxkplgyglxtskfmwum.supabase.co/functions/v1/vklite-contract-router-v2'
const CONTRACT_PUBLIC_API = 'https://sgxxkplgyglxtskfmwum.supabase.co/functions/v1/vklite-contract-public'
const nativeFetch = window.fetch.bind(window)

window.fetch = async (input, init) => {
  const rawUrl = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url
  if (rawUrl.startsWith(CONTRACT_LEGACY_API)) {
    const url = new URL(rawUrl)
    const action = url.searchParams.get('action') || ''
    let payload: Record<string, unknown> = {}
    if (typeof init?.body === 'string') {
      try { payload = JSON.parse(init.body) as Record<string, unknown> } catch { payload = {} }
    }

    if (action === 'public_get') {
      const token = String(payload.token || '')
      return nativeFetch(`${CONTRACT_PUBLIC_API}?action=get&token=${encodeURIComponent(token)}`, {
        method: 'GET',
        cache: 'no-store',
        signal: init?.signal,
      })
    }

    if (action === 'public_sign') {
      return nativeFetch(`${CONTRACT_PUBLIC_API}?action=sign`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: { 'content-type': 'text/plain;charset=UTF-8' },
        cache: 'no-store',
        signal: init?.signal,
      })
    }
  }

  return nativeFetch(input, init)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    const basePath = __BASE_PATH__.endsWith('/') ? __BASE_PATH__ : `${__BASE_PATH__}/`;
    const register = () => navigator.serviceWorker.register(`${basePath}sw.js`, { scope: basePath }).catch(() => {});
    const idleCallback = (window as Window & { requestIdleCallback?: (callback: () => void) => number }).requestIdleCallback;
    if (idleCallback) {
      idleCallback(register);
    } else {
      window.setTimeout(register, 1000);
    }
  });
}
